import { render, staticRenderFns } from "./Cjhd.vue?vue&type=template&id=0dc61b8e&scoped=true"
import script from "./Cjhd.vue?vue&type=script&lang=js"
export * from "./Cjhd.vue?vue&type=script&lang=js"
import style0 from "./Cjhd.vue?vue&type=style&index=0&id=0dc61b8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc61b8e",
  null
  
)

export default component.exports